import React from 'react';
import ResetPassword from '../../@jumbo/components/Common/authComponents/ResetPassword';

const CreateResetPassword = () => <ResetPassword variant="standard"/>;

export default CreateResetPassword;
